import { render, staticRenderFns } from "./KanbanDetailDialog.vue?vue&type=template&id=3d017fde&scoped=true&lang=pug&"
import script from "./KanbanDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./KanbanDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./KanbanDetailDialog.vue?vue&type=style&index=0&id=3d017fde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d017fde",
  null
  
)

export default component.exports